module.exports = __webpack_public_path__ + "static/media/2.4030e46f.jpg";